<template>
  <div class="background-cover">
    <p class="background-credit">
      <a href="https://unsplash.com/photos/PXWe1jMsf9o" target="_blank">
        Photo
      </a>
      by Ethan Ou on Unsplash
    </p>
  </div>
</template>

<script>
import { isAuthenticated } from "@/lib/auth";

export default {
  name: "Auth",
  mounted: async function() {
    return isAuthenticated()
      ? this.$router.push({
          name: "Home"
        })
      : this.$modal.show("auth");
  }
};
</script>

<style scoped></style>
